// Tasks and notes, kept with the timers (the Timers panel, T): a short checklist and a notepad as plain data. Pure:
// site/js/app.js renders and stores them (`lofi-cities:tasks`, `lofi-cities:notes`), and a signed-in visitor's account
// keeps them like a setting, the newest change winning (worker/account.js SETTING_ROOM has the room for their text).
export const TASKS_MAX = 12;              // tasks kept: a list for one sitting, not a planner
export const TASK_LEN = 60;               // characters in a task
export const NOTES_LEN = 2000;            // characters in the notes

const chars = (text, max) => Array.from(text).slice(0, max).join('');   // whole characters: never half an emoji

/** A task as typed: one line, single spaces, TASK_LEN characters at most ('' for nothing to add). */
export const cleanTask = text => (typeof text === 'string' ? chars(text.replace(/[^\P{Cc}\s]/gu, '').replace(/\s+/g, ' ').trim(), TASK_LEN).trim() : '');

/** The stored (or synced) tasks, well-formed: [{ t: text, d: done }], TASKS_MAX at most. Anything else is left out. */
export function cleanTasks(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  for (const e of raw) {
    const t = e && typeof e === 'object' ? cleanTask(e.t) : '';
    if (t) out.push({ t, d: e.d === true });
    if (out.length === TASKS_MAX) break;
  }
  return out;
}

/** The stored (or synced) notes: text with its line breaks and tabs, NOTES_LEN characters at most. */
export const cleanNotes = raw => (typeof raw === 'string' ? chars(raw.replace(/\r\n?/g, '\n').replace(/[^\P{Cc}\n\t]/gu, ''), NOTES_LEN) : '');

export const tasksFull = tasks => tasks.length >= TASKS_MAX;
/** `tasks` with a new one at the end; the same list when there's nothing to add or no room. */
export function addTask(tasks, text) {
  const t = cleanTask(text);
  return t && !tasksFull(tasks) ? [...tasks, { t, d: false }] : tasks;
}
export const toggleTask = (tasks, i) => tasks.map((task, j) => (j === i ? { ...task, d: !task.d } : task));
export const removeTask = (tasks, i) => tasks.filter((_, j) => j !== i);
export const clearDone = tasks => tasks.filter(task => !task.d);
export const doneCount = tasks => tasks.filter(task => task.d).length;

/** The line beside "Tasks": '' for none, "all done", or "2 of 5 done". */
export function tasksLine(tasks) {
  const done = doneCount(tasks);
  return !tasks.length ? '' : done === tasks.length ? 'all done' : `${done} of ${tasks.length} done`;
}
